<div class="form-control mb-3 pointer" *ngIf="isMaterialExpanded" [class.form-control-active]="isSelected"
     (click)="onExpandMaterial()">
  <div class="d-flex">
    <app-tag class="mr-2" [sector]="material.sector" [isActive]="true"></app-tag>
    <b>{{ material.materialName }}</b>
    - {{ material.quantityPlanned | digitFormat }} {{ material?.normativeValue ? 'M2' : material.materialUnit }}
    <div class="ml-10">
      <i class="pointer" [ngClass]="isCollapsed ? 'fa fa-angle-up' :'fa fa-angle-down'"></i>
    </div>
  </div>
  <div class="d-none" [class.d-flex]="isCollapsed">
    <div>
      <div class="mt-2" *ngIf="material.comment"><b>Komentar:</b> {{ material.comment }}</div>
      <div class="mt-1" *ngIf="material.workRequestMaterialId">
        <b>Jedinična cena: </b>
        <span *ngIf="material.isLocked">{{ material.lockedUnitPrice / exchangeRate | digitFormat }} <i
          class="fa fa-lock"></i>
          ({{ material?.normativeValue ? ((material.currentUnitPrice * material?.normativeValue) / exchangeRate | digitFormat) : (material.currentUnitPrice / exchangeRate | digitFormat) }}
          )
        </span>
        <span
          *ngIf="!material.isLocked">{{ material?.normativeValue ? ((material.currentUnitPrice * material?.normativeValue) / exchangeRate | digitFormat) : (material.currentUnitPrice / exchangeRate | digitFormat) }}</span>
        (EUR)
      </div>
      <div class="mt-1" *ngIf="material.workRequestMaterialId && material.isCustomPriceSet">
        <b>Korigovana cena: </b>
        {{ material.customUnitPrice / exchangeRate | number: '1.0-6':'sr-Latn' }}  (EUR)
      </div>
      <div class="mt-1" *ngIf="material.workRequestMaterialId">
        <b>Ukupna cena: </b>
        <span *ngIf="material.isLocked">{{ material.lockedPrice / exchangeRate | number: '1.0-6':'sr-Latn' }} <i
          class="fa fa-lock"></i>
          ({{ material?.normativeValue ? ((material.currentPrice * material?.normativeValue) / exchangeRate | number: '1.0-6':'sr-Latn') : (material.currentPrice / exchangeRate | number: '1.0-6':'sr-Latn') }}
          )
        </span>
        <span *ngIf="!material.isLocked">
          {{ material?.normativeValue ? ((material.currentPrice * material?.normativeValue) / exchangeRate | number: '1.0-6':'sr-Latn') : (material.currentPrice / exchangeRate | number: '1.0-6':'sr-Latn') }}
        </span>

        (EUR)
      </div>
      <div class="mt-2" *ngIf="userSectors.includes(material.sector)">
        <button type="button" class="btn btn-icon btn-success btn-sm mr-3 ml-auto"
                *ngIf="!isAdditional && permissionHelper.isEnabledMethod('approveRequestedMaterialForWorkRequest')"
                (click)="onApproveMaterial(material)"
                [class.btn-secondary]="!material.isApproved"
                ngxClickStopPropagation><i class="fa fa-check"></i></button>

        <app-delete *ngIf="permissionHelper.isEnabledMethod('deleteRequestedMaterialForWorkRequest')"
                    (selected)="onDeleteMaterial(material)" ngxClickStopPropagation></app-delete>
        <i class="fa fa-edit ml-3 pointer"
           *ngIf="!material.isApproved && permissionHelper.isEnabledMethod('editRequestedWorkRequestMaterial')"
           (click)="onSelectMaterial(material)" ngxClickStopPropagation></i>
      </div>
    </div>
  </div>
</div>

<div class="form-control mb-3 pointer" *ngIf="!isMaterialExpanded" [class.form-control-active]="isSelected">
  <div class="d-flex">
    <app-tag class="mr-2" [sector]="material.sector" [isActive]="true"></app-tag>
    <b>{{ material.materialName }}</b>
    - {{ material.quantityPlanned | digitFormat }} {{ material?.normativeValue ? 'M2' : material.materialUnit }}
  </div>
  <div>
    <div>
      <div class="mt-2" *ngIf="material.comment"><b>Komentar:</b> {{ material.comment }}</div>
      <div class="mt-1" *ngIf="material.workRequestMaterialId">
        <b>Jedinična cena: </b>
        <span *ngIf="material.isLocked">{{ material.lockedUnitPrice | digitFormat }} <i class="fa fa-lock"></i>
          ({{ material.currentUnitPrice | digitFormat }})
        </span>
        <span *ngIf="!material.isLocked">{{ material.currentUnitPrice | digitFormat }}</span>
      </div>
      <div class="mt-1" *ngIf="material.workRequestMaterialId">
        <b>Ukupna cena: </b>
        <span *ngIf="material.isLocked">{{ material.lockedPrice | digitFormat }} <i class="fa fa-lock"></i>
          ({{ material.currentPrice | digitFormat }})
        </span>
        <span *ngIf="!material.isLocked">
          {{ (material.isCustomPriceSet ? material.customUnitPrice : material.currentPrice) | digitFormat }}
        </span>
      </div>
      <div class="mt-2" *ngIf="userSectors.includes(material.sector)">
        <button type="button" class="btn btn-icon btn-success btn-sm mr-3 ml-auto"
                *ngIf="!isAdditional && permissionHelper.isEnabledMethod('approveRequestedMaterialForWorkOrder')"
                (click)="onApproveMaterial(material)"
                [class.btn-secondary]="!material.isApproved"
                ngxClickStopPropagation><i class="fa fa-check"></i></button>

        <app-delete *ngIf="permissionHelper.isEnabledMethod('deleteRequestedMaterialForWorkOrder') && !material?.quantityIssued"
                    (selected)="onDeleteMaterial(material)" ngxClickStopPropagation></app-delete>
        <i class="fa fa-edit ml-3 pointer"
           *ngIf="!material.isApproved && permissionHelper.isEnabledMethod('editRequestedWorkOrderMaterial')"
           (click)="onSelectMaterial(material)" ngxClickStopPropagation></i>
      </div>
    </div>
  </div>
</div>
